/**
 * Dynamic API Module
 * A utility module that provides a flexible interface for making HTTP requests
 * Handles different HTTP methods with consistent error handling and configuration
 */

import axios from "axios";
import { config } from "../../../utils/custom-local-storage";

/**
 * Makes dynamic HTTP requests to the server with specified method and data
 *
 * @param {string} method - The HTTP method to use ('get', 'post', 'put', 'delete')
 * @param {string} url - The endpoint URL (will be appended to base server URL)
 * @param {Object} obj - The data object to send with the request (default empty object)
 * @returns {Promise<any>} Response data from the server
 * @throws {Error} Throws error response from server if request fails
 */
const dynamicAPI = async (method, url, obj = {}) => {
  try {
    switch (method) {
      case "get":
        return await axios
          .get(`${process.env.REACT_APP_SERVER_URL}${url}`, config())
          .then((res) => res.data);

      case "post":
        return await axios
          .post(`${process.env.REACT_APP_SERVER_URL}${url}`, obj, config())
          .then((res) => res.data);

      case "put":
        return await axios
          .put(`${process.env.REACT_APP_SERVER_URL}${url}`, obj, config())
          .then((res) => res.data);

      case "delete":
        return await axios
          .delete(`${process.env.REACT_APP_SERVER_URL}${url}`, config())
          .then((res) => res.data);
      default:
        return null;
    }
  } catch (error) {
    throw error.response.data.error;
  }
};

export default dynamicAPI;
